<template>
    <div>
        <div class="head">
            <img src="../../static/img/01.png" alt="松科智能" class="head_icon" @click="goIndex">
            <div class="navbar">
                <div class="navbar_horizontal" v-if="show_horizontal">
                    <div :class="{ navbar_horizontal_item : activeIndex == index, navbar_horizontal_item1 : activeIndex != index }" v-for="(item, index) in navbar" :key="index" @click="handleSelect(index)">
                        {{item.title}}
                    </div>
                </div>
                <div class="navbar_vertical" v-else>
                    <div @click="drawer = true">
                        <div class="heng"></div>
                        <div class="heng"></div>
                        <div class="heng"></div>
                    </div>
                    <el-drawer
                        :visible.sync="drawer"
                        :show-close="false"
                        direction="ttb">
                        <div class="search1">
                            <el-input
                                placeholder="输入关键词搜索" @change="Search()"
                                v-model="keyword" style="border:none;">
                            </el-input>
                            <img src="../../static/img/07.png" class="search_button1" @click="Search()">
                        </div>
                        <div class="draw_navbar">
                            <div class="draw_navbar_item" :class="{ draw_navbar_item1 : activeIndex == index, draw_navbar_item : activeIndex != index }" v-for="(item, index) in navbar" :key="index" @click="handleSelect(index)">
                                {{item.title}}
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
            <div class="search" v-if="show_horizontal">
                 <el-input
                    placeholder="输入关键词搜索" @change="Search()"
                    v-model="keyword" style="border:none;">
                </el-input>
                <img src="../../static/img/02.png" class="search_button" @click="Search()">
            </div>
        </div>
        <div class="index">
            <div v-for="(item, index) in list" :key="index">
                <div class="index1" v-if="item.arts !== undefined && item.arts.length > 0">
                    <div class="index1_top">
                        <div class="index1_name">{{item.title}}</div>
                        <div class="index1_right">
                            <div class="index1_more">
                                <router-link target="_blank" :to="{name:'List', query: { m_id: navbar[activeIndex].id, m_index: activeIndex, md_id: item.id }}">
                                    更多
                                </router-link>
                            </div>
                            <el-image src="../../static/img/05.png" style="width: 16px; height: 16px; margin-top: 1.5px;"></el-image>
                        </div>
                    </div>
                    <div class="index1_content">
                        <div v-for="(item1, index1) in item.arr" :key="index1" class="index1_content1">
                            <div class="index1_item" v-for="(item2, index2) in item1" :key="index2">
                                <div class="index1_item_date">[{{item2.created_at | Time()}}]</div>
                                <div class="index1_item_name">
                                    <router-link target="_blank" :to="{name:'Detail', params: { id: item2.id }, query: { m_index: activeIndex, md_id: item2.md_id, title: item.title }}">
                                        {{item2.title}}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear" v-if="item.arts !== undefined && item.arts.length > 0"></div>
            </div>
        </div>
        <div class="clear"></div>
        <Foot></Foot>
    </div>
</template>

<script>
export default {
    data () {
        return {
            drawer: false,
            show_horizontal: true, // 切换导航栏显示方式
            is_list: true, // 切换文章列表显示方式
            navbar: [], // 导航栏列表
            activeIndex: 0,
            list: [],
            keyword: '' // 搜索关键词
        }
    },
    created () {
        if (this.$route.query.index) {
            this.activeIndex = this.$route.query.index
            // 获取导航栏
            this.getNavBar(this.$route.query.index)
        } else {
            // 获取导航栏
            this.getNavBar(0)
        }
        var screenWidth = window.screenWidth || document.body.clientWidth
        if (screenWidth < 768) {
            this.is_list = false
            this.show_horizontal = false
        } else {
            this.is_list = true
            this.show_horizontal = true
        }
    },
    mounted () {
        const that = this
        window.addEventListener('resize', () => {
            var screenWidth = window.screenWidth || document.body.clientWidth
            if (screenWidth < 768) {
                that.is_list = false
                that.show_horizontal = false
            } else {
                that.is_list = true
                that.show_horizontal = true
            }
        }, false)
    },
    filters: {
        Time (value) {
            var arr = value.split(' ')[0].split('-')
            return arr[0] + '/' + arr[1] + '-' + arr[2]
        }
    },
    beforeRouteEnter (to, from, next) {
        window.document.body.style.backgroundColor = '#FFFFFF'
        next()
    },
    beforeRouteLeave (to, from, next) {
        window.document.body.style.backgroundColor = ''
        next()
    },
    methods: {
        // 跳转到首页
        goIndex () {
            this.$router.push('/')
        },
        // 获取导航栏
        getNavBar (index) {
            this.$axios.get('/menus')
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            this.navbar = res.data.data
                            // 获取指定模块的数据
                            this.getList(res.data.data[index].id)
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        // 选择导航栏
        handleSelect (index) {
            this.activeIndex = index
            this.drawer = false
            this.getList(this.navbar[index].id)
        },
        // 获取指定模块的数据
        getList (id) {
            this.$axios.get(`/${id}/get_art_list`)
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            var data = res.data.data
                            for (var i = 0; i < data.length; i++) {
                                var arts = data[i].arts
                                if (arts.length !== 0) {
                                    var num = Math.ceil((arts.length) / 2)
                                    var arr1 = [[], []]
                                    for (var j = 0; j < arts.length; j++) {
                                        if (j < num) {
                                            arr1[0].push(arts[j])
                                        } else {
                                            arr1[1].push(arts[j])
                                        }
                                    }
                                    data[i].arr = arr1
                                }
                            }
                            this.list = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        // 传递搜索关键词给组件Index
        Search () {
            if (this.keyword) {
                this.drawer = false
                const url1 = this.$router.resolve({name: 'List', query: { m_id: this.navbar[this.activeIndex].id, m_index: this.activeIndex, keyword: this.keyword }})
                window.open(url1.href, '_blank')
            } else {
                this.$message({
                    showClose: true,
                    message: '请输入关键字',
                    type: 'warning',
                    duration: '1500',
                    offset: '80'
                })
            }
        }
    }
}
</script>

<style scoped>
    @import "./index.css";
</style>



// WEBPACK FOOTER //
// src/view/index.vue